import React from "react";
import "./style.scss";

const SmsIcon = () => {
  return (
    <svg
      className="sms-icon"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512">
      <circle cx="256" cy="256" r="256" />
      <g>
        <polygon className="fill-1" points="365.52,398.88 365.52,320.8 267.92,320.8 	" />
        <path
          className="fill-1"
          d="M358,336H153.92C117.68,336,88,306.32,88,270.08v-76.16c0-36.24,29.68-65.92,65.92-65.92h204.16
        c36.24,0,65.92,29.68,65.92,65.92v76.16C424,306.32,394.32,336,358,336z"
        />
      </g>
      <path
        d="M147.12,254c3.76,2.48,10.4,5.04,16.8,5.04c9.28,0,13.6-4.64,13.6-10.4c0-6.08-3.6-9.44-13.04-12.88
      c-12.56-4.48-18.56-11.44-18.56-19.84c0-11.28,9.12-20.56,24.16-20.56c7.12,0,13.28,2,17.2,4.32l-3.2,9.28
      c-2.72-1.76-7.84-4.08-14.32-4.08c-7.52,0-11.76,4.32-11.76,9.52c0,5.76,4.16,8.4,13.28,11.84c12.16,4.64,18.4,10.72,18.4,21.12
      c0,12.32-9.52,20.96-26.16,20.96c-7.68,0-14.8-1.92-19.68-4.8L147.12,254z"
      />
      <path
        d="M206.16,216c0-7.2-0.16-13.2-0.56-18.96h11.12l0.56,11.28h0.4c3.92-6.64,10.4-12.88,22-12.88c9.52,0,16.8,5.76,19.84,14.08
      h0.32c2.16-3.92,4.88-6.96,7.84-9.12c4.24-3.2,8.8-4.96,15.52-4.96c9.28,0,23.04,6.08,23.04,30.4v41.28h-12.48v-39.68
      c0-13.44-4.96-21.6-15.2-21.6c-7.2,0-12.88,5.36-15.04,11.6c-0.56,1.76-1.04,4.08-1.04,6.4v43.28H250v-42
      c0-11.12-4.88-19.28-14.64-19.28c-7.92,0-13.76,6.4-15.76,12.72c-0.72,1.92-1.04,4.08-1.04,6.24v42.24h-12.48V216H206.16z"
      />
      <path
        d="M325.2,254c3.76,2.48,10.4,5.04,16.8,5.04c9.28,0,13.6-4.64,13.6-10.4c0-6.08-3.6-9.44-13.04-12.88
      C330,231.28,324,224.32,324,215.92c0-11.28,9.12-20.56,24.16-20.56c7.12,0,13.28,2,17.2,4.32l-3.2,9.28
      c-2.72-1.76-7.84-4.08-14.32-4.08c-7.52,0-11.76,4.32-11.76,9.52c0,5.76,4.16,8.4,13.28,11.84c12.16,4.64,18.4,10.72,18.4,21.12
      c0,12.32-9.52,20.96-26.16,20.96c-7.68,0-14.8-1.92-19.68-4.8L325.2,254z"
      />
    </svg>
  );
};

export default SmsIcon;
